import { useState } from "react";
import type { JsonSchema, LayoutProps } from "@jsonforms/core";
import { useCaseReviewContext } from "./useCaseFieldReview";
import { caseReviewGroupFields } from "../utils/caseReviewSubsections";
import { EMPTY_REVIEW_COUNTS } from "../utils/reviewCounts";

/** Shared group behavior; record tables may retain open groups across record selection. */
export function useCaseReviewGroup(props: LayoutProps) {
  const context = useCaseReviewContext();
  const [collapsed, setCollapsed] = useState(false);
  const label = (props.uischema as { label?: string }).label;
  const fieldKeys = caseReviewGroupFields(props.uischema);
  const hasError = !!props.enabled && fieldKeys.some((key) => {
    const field = fieldAtPath(props.schema, key);
    const fieldId = (field as Record<string, unknown> | undefined)?.["x-field-id"];
    return !!(context.serverErrors?.[key]
      || (typeof fieldId === "string" && context.serverErrors?.[fieldId]));
  });
  const open = hasError || (context.toggleGroup
    ? context.openGroups?.has(label ?? "") ?? false : !collapsed);
  const toggle = () => {
    if (context.toggleGroup && label) context.toggleGroup(label);
    else setCollapsed((value) => !value);
  };
  const counts = context.countsFor?.(fieldKeys) ?? EMPTY_REVIEW_COUNTS;
  return { context, label, open, toggle, counts };
}

function fieldAtPath(schema: JsonSchema, path: string): JsonSchema | undefined {
  let field: JsonSchema | undefined = schema;
  for (const part of path.split(".")) field = field?.properties?.[part];
  return field;
}
